import { observer } from 'mobx-react-lite'
import { captureException } from 'app/lib/capture-exception'
import { useStores } from 'app/store'
import { useRouter } from 'solito/router'
import { useCurrentPath } from 'app/hooks/use-current-path'
import { UpsellModal, CelebrationModal } from 'app/components/modals'
import { useQueryClient } from 'react-query'

export const UpgradeFlowModals = observer(() => {
  const { upgradeModalState, userStore } = useStores()
  const router = useRouter()
  const { path: currentPath } = useCurrentPath()
  const queryClient = useQueryClient()

  const handleCelebrationClose = async () => {
    const needsAck = upgradeModalState.finalizeCelebrationModal()
    const returnPath = upgradeModalState.upgradeReturnPath
    if (returnPath) {
      upgradeModalState.clearUpgradeReturnPath()
    }

    try {
      if (needsAck) {
        await userStore?.acknowledgeUpgradeCelebration()
      }
      // Refresh access immediately after upgrade so entitlement checks update.
      await userStore?.refreshAccessToken()
      // Then refetch active queries to clear stale locked state.
      await queryClient.invalidateQueries(undefined, {
        refetchActive: true,
        refetchInactive: false,
      })
    } catch (error) {
      console.error('[UpgradeFlowModals] Failed to handle celebration close:', error)
      captureException(error)
    } finally {
      if (returnPath && (!currentPath || currentPath !== returnPath)) {
        router.push(returnPath)
      }
    }
  }

  return (
    <>
      <UpsellModal
        open={upgradeModalState.showUpsellModal}
        onOpenChange={(open) => {
          if (!open) upgradeModalState.closeUpsellModal()
        }}
      />

      <CelebrationModal
        open={upgradeModalState.showCelebrationModal}
        onOpenChange={handleCelebrationClose}
      />
    </>
  )
})
